import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable,throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';

@Injectable({providedIn: 'root'})

export class EmailService {
	private readonly apiUrl = environment.apiUrl;

	constructor(private http: HttpClient) {}

	sendEmail(data: {
		name: string;email: string;message: string
	}): Observable < any > {
		console.log('Datos enviados a la API para env�o de correo:', data);

		return this.http.post(`${this.apiUrl}/userForm`, data).pipe(
			catchError(error => {
				console.error('Error al enviar el correo', error);
				throw error;
			})
		);
	}

	subscribeToNewsletter(data: {
		email: string
	}): Observable < any > {
		console.log('Datos enviados a la API para suscripci�n al bolet�n:', data);

		return this.http.post(`${this.apiUrl}/api/newsletter/subscribe`, data).pipe(
			catchError(error => {
				console.error('Error al suscribirse al bolet�n', error);

				if (error.status === 409) {

					return throwError(() => new Error('�Ups! Este correo ya est� suscrito. No te preocupes, te mantendremos informado.'));
				}


				return throwError(() => new Error('Hubo un error al suscribirse. Int�ntalo nuevamente.'));
			})
		);
	}
}